import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../../../../../infra/dls/components/button/button';
import { TextM } from '../../../../../infra/dls/components/typography';
import styles from './styles.module.scss';
export var ContactSupportFooter = function (_a) {
    var onContactSupport = _a.onContactSupport;
    return (_jsxs("div", { className: styles['two-fa-contact-footer'], children: [_jsx(TextM, { color: "secondary", children: "Having trouble?" }), _jsx(Button.TextLink, { type: "button", className: "u-p0", onClick: onContactSupport, children: "Contact Support" })] }));
};
